<template>
  <v-sheet color="grey800" class="px-4 py-2 grey200--text">
    <v-form v-model="valid" @submit.prevent="onSave">
      <v-row>
        <v-col cols="12" class="p-0">
          <label
            v-t="'Display name'"
            for="fieldName" class="grey100--text d-block font-weight-bold"
          />
          <p class="body-2 lh-1-2 mb-3">
            Tired of being a roleplayer? Change your name here if your Steam name contains banned words.
          </p>

          <v-text-field
            id="fieldName" v-model="input" :rules="rules"
            placeholder="Not a roleplayer..."
            hint="(Max 28 chars, no websites or bad words)"
            class="settings-btn rounded-0"
            dense solo flat
            persistent-hint
            background-color="grey600"
          >
            <template #append-outer>
              <v-btn
                v-t="'cta.save'"
                class="px-8 font-weight-semibold text-caption green500--text rounded-0" color="green800"
                height="38" :ripple="false"
                depressed
                :disabled="!valid"
                :loading="loading"
                @click="onSave"
              />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    loading: Boolean,
  },
  data() {
    return {
      valid: false,
      input: this.value,
      rules: [
        v => !!v || 'Required',
        v => v.length <= 28 || 'Too long',
      ],
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/session',
    }),
  },
  methods: {
    onSave() {
      if (!this.valid) return
      this.$emit('update', this.input)
    },
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .settings-btn {
    .v-input__append-outer {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  }
</style>
